import { NgModule } from '@angular/core';
import { MenusReactWrapperComponent } from './menus-react-wrapper.component';

@NgModule({
  declarations: [MenusReactWrapperComponent],
  exports: [MenusReactWrapperComponent],
})
export class MenusModule {}
